<h2 mat-dialog-title>Edit Featured Image</h2>
<mat-dialog-content>
    <div class="image-details">
        <div fxFlex="650px">
            <div class="image-holder quiz" fxLayout="row">
                <div class="left">
                    <cropper
                        #cropperEl
                        [canEdit]="data.canEdit" 
                        [image]="data.image"
                        [size]="data.size">
                    </cropper>
                </div>
            </div>
        </div>
        <div fxFlex>
            <div class="details" fxFlex fxLayout="column" fxLayoutGap="10px">
                <div class="wysiwyg">
                    <label>Image title</label>
                    <richtext
                        class="h2"
                        [(value)]="data.image.title"
                        (valueChange)="cleanText('title')"
                        placeholder="Image title"
                        *ngIf="data.canEdit; else titleText"
                        [dialog]="true"
                        [removeButtons]="true">
                    </richtext>
                    <ng-template #titleText>
                        <div [ngClass]="{faded: !data.image.title}">{{data.image.title ? data.image.title : 'Image title'}}</div>
                    </ng-template>
                    <div class="word-count"></div>
                </div>
                <div class="wysiwyg">
                    <label>Alt Text</label>
                    <richtext
                        [(value)]="data.image.alt"
                        (valueChange)="cleanText('alt')"
                        placeholder="Alt text"
                        *ngIf="data.canEdit; else altText"
                        [dialog]="true"
                        [removeButtons]="true">
                    </richtext>
                    <ng-template #altText>
                        <div [ngClass]="{faded: !data.image.alt}">{{data.image.alt ? data.image.alt : 'Alt text'}}</div>
                    </ng-template>
                    <div class="word-count"></div>
                </div>
                <div id="options-panel">
                    <label>Brightness</label>
                    <mat-slider [disabled]="data.canEdit !== true" min="-0.75" max="0.75" step=".05" [(value)]="brightness" (change)="optionChange($event, 'brightness')"></mat-slider>
                    <label>Contrast</label>
                    <mat-slider [disabled]="data.canEdit !== true" min="-0.5" max="0.5" step=".01" [(value)]="contrast" (change)="optionChange($event, 'contrast')"></mat-slider>
                    <div class="actions">
                        <button [disabled]="data.canEdit !== true" (click)="resetOptions()"><mat-icon>replay</mat-icon></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button class="button faded" mat-dialog-close>Done</button>
</mat-dialog-actions>